<template>
  <!-- Perfect Holiday Cabin Section -->
  <section class="perfect-holiday-cabin-section common-padding">
    <div class="holiday-cabin-img-slider owl-carousel">
      <Carousel
        :wrap-around="true"
        :settings="settings"
        :breakpoints="breakpoints"
      >
        <Slide v-for="item in IndexNineHoliday" :key="item.id">
          <div class="item">
            <img
              :src="require(`@/assets/img/bg/${item.image}`)"
              class="img-fluid"
              alt=""
            />
            <div class="container">
              <div class="holiday-cabin-info" data-aos="fade-up">
                <div class="rate-per-day">
                  <span>{{ item.price }} /</span>
                  <h6>Per night</h6>
                </div>
                <div class="section-heading">
                  <h2>{{ item.title }}</h2>
                  <p>{{ item.text }}</p>
                </div>
                <div class="room-categories">
                  <span
                    ><img
                      src="@/assets/img/icons/area-icon.svg"
                      class="img-fluid"
                      alt=""
                    />Area:{{ item.area }}</span
                  >
                  <span
                    ><img
                      src="@/assets/img/icons/bed-icon.svg"
                      class="img-fluid"
                      alt=""
                    />Beds:{{ item.beds }}</span
                  >
                  <span
                    ><img
                      src="@/assets/img/icons/floor-icon.svg"
                      class="img-fluid"
                      alt=""
                    />Floors:{{ item.floors }}</span
                  >
                  <span
                    ><img
                      src="@/assets/img/icons/guest-icon.svg"
                      class="img-fluid"
                      alt=""
                    />Guest:{{ item.guest }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </section>
  <!-- /Perfect Holiday Cabin Section -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexNineHoliday from "@/assets/json/indexNineHoliday.json";
export default {
  data() {
    return {
      IndexNineHoliday: IndexNineHoliday,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1000: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mouted() {},
};
</script>
